import React from "react";

const Comment = ({ comment }) => {
  const { id, author, body, created_utc } = comment.data;

  console.log(id);
  console.log(author);

  const getUtcTime = (utcHours) => {
    let currentTime = Date.now() / 1000;
    let timeHour = (currentTime - utcHours) / 60 / 60;
    let timePassed;

    if (timeHour < 24) timePassed = Math.floor(timeHour) + " h ago";
    else timePassed = Math.floor(timeHour / 24) + "d ago";
    return timePassed;
  };

  return (
    <div key={id} className="comment">
      <div className="comment-details">
        <h4 className="comment-details-child">{author} : </h4>
        <p className="comment-details-child">{getUtcTime(created_utc)}</p>
      </div>

      <div>
        <p>{body}</p>
      </div>
      <hr />

      {/*<div>
        <img src={arrowImg} alt="arrow" className="arrow-button" />
        <p>Upvotes: {upvote >= 1000 ? upvote / 1000 + "k" : upvote}</p>
      </div>*/}
    </div>
  );
};

export default Comment;
